const id_trans_production = {
    "": "proses barang",
    add: "tambah proses barang",
    edit: "ubah proses barang",
    from_whs: "dari gudang",
    to_whs: "ke gudang",
}

export default id_trans_production;